import { useMediaQuery } from '@mui/material';
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Basket } from '../../../../Modules/Basket';
import { useAppDispatch } from '../../../../hooks/redux';
import { useBasket } from '../../../../hooks/useBasket';
import { useCard } from '../../../../hooks/useCard';
import { useReview } from '../../../../hooks/useReview';
import { useUser } from '../../../../hooks/useUser';

export const useCardInteraction = () => {
  const navigation = useNavigate();
  const dispatch = useAppDispatch();
  const { loggedIn } = useUser();
  const { catalog_item } = useCard();
  const { items: basketItems } = useBasket();
  const { reviewStarsAvg, reviewsCommentsCount } = useReview();
  const mobileScreen = useMediaQuery('(max-width:539px)');
  const isAvailability =
    catalog_item.availability === 'availability' &&
    catalog_item.availability_count >= 1;
  let isItemExistBasket = Basket.isItemExistBasket(
    //Есть ли товар такой в корзине
    basketItems,
    Number(catalog_item.id)
  ); // Поулчаем товар по Id
  const [isSmashedBasket, setIsSmashedBasket] = useState(isItemExistBasket);

  const addToCart = async (item: any) => {
    if (isItemExistBasket) return navigation('/basket'); //Перенаправлеям на страницу корзины, если товар уже добавлен
    setIsSmashedBasket(!isSmashedBasket);
    await Basket.add_to_cart(item, basketItems, dispatch); //Синхронизация при добавлении товара в корзину
    if (loggedIn) await Basket.basketSynchronization(dispatch); //Вызов синхронизации корзины с сервером, если залогинен
  };
  const handleScroll = () => {
    const block = document.getElementById('myBlock');
    if (block) {
      block.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return useMemo(
    () => ({
      cardInteraction: {
        isItemExistBasket,
        isAvailability,
        countStars: Number(reviewStarsAvg || 0),
        countReviews: Number(reviewsCommentsCount || 0),
        mobileScreen,
      },
      actions: { handleScroll, addToCart },
    }),
    [
      isItemExistBasket,
      isAvailability,
      reviewStarsAvg,
      reviewsCommentsCount,
      mobileScreen,
    ]
  );
};
